import { createSlice } from '@reduxjs/toolkit';
import {
    fetchAllHolidays,
    fetchHolidays,
    createHoliday,
    updateHoliday,
    deleteHoliday,
} from '../thunks/holidayThunks.js';

const initialState = {
    fullList: [],
    list: [],
    maxPageNumber: 0,
    loading: false,
    error: '',
};

const holidaysSlice = createSlice({
    name: 'holidays',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchAllHolidays.pending, (state) => {
                state.loading = true;
                state.error = '';
            })
            .addCase(fetchAllHolidays.fulfilled, (state, action) => {
                state.fullList = action.payload;
                state.loading = false;
            })
            .addCase(fetchAllHolidays.rejected, (state, action) => {
                state.error = action.payload || action.error?.message;
                state.loading = false;
            })
            .addCase(fetchHolidays.pending, (state) => {
                state.loading = true;
                state.error = '';
            })
            .addCase(fetchHolidays.fulfilled, (state, action) => {
                state.list = action.payload.list;
                state.maxPageNumber = action.payload.maxPageNumber;
                state.loading = false;
            })
            .addCase(fetchHolidays.rejected, (state, action) => {
                state.error = action.payload || action.error?.message;
                state.loading = false;
            })
            .addCase(createHoliday.fulfilled, (state, action) => {
                state.list.unshift(action.payload);
            })
            .addCase(createHoliday.rejected, (state, action) => {
                state.error = action.payload || action.error.message;
            })
            .addCase(updateHoliday.fulfilled, (state, action) => {
                const { data, id } = action.payload;
                state.list = state.list.map((holiday) => (holiday.id === id ? { ...data, id } : holiday));
            })
            .addCase(updateHoliday.rejected, (state, action) => {
                state.error = action.payload || action.error.message;
            })
            .addCase(deleteHoliday.fulfilled, (state, action) => {
                state.list = state.list.filter(({ id }) => id !== action.payload);
            })
            .addCase(deleteHoliday.rejected, (state, action) => {
                state.error = action.payload || action.error.message;
            })
            .addDefaultCase((state) => state);
    },
});

export default holidaysSlice.reducer;
